import React, {Component} from 'react';
import '@shopify/polaris/styles.css';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import Login from "./pages/login/login";
import Admin from "./pages/admin/admin";
import Signup from "./pages/signup/signup";
import ForgotPassword from "./pages/forgotPassword/forgotPassword";
import RecoverPassword from "./pages/recoverPassword/recoverPassword";

export default class App extends Component{

    render () {
        return (
          <BrowserRouter>
            <Switch>
              <Route path='/login' component={Login}></Route>
              <Route path='/signup' component={Signup}></Route>
              <Route path='/forgotpassword' component={ForgotPassword}></Route>
              <Route path='/recoverpassword' component={RecoverPassword}></Route>
              <Route path='/' component={Admin}></Route>
            </Switch>
          </BrowserRouter> 
        )
    }
}